export default __webpack_public_path__ + "static/media/sample1.cd25580f.jpeg";